import React, { useState } from "react";
import { Table } from "antd";

const Datatable = ({
  columns,
  dataSource,
  onRowSelectionChange,
  isLoading,
  totalCount,
  rowKey,
  scrollX = false,
}) => {


    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };


    const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (onRowSelectionChange) {
      onRowSelectionChange(newSelectedRowKeys, selectedRows);
    }
  };
  return (
    <div>
      <Table
        className="table datanew dataTable no-footer"
         rowSelection={{
          selectedRowKeys,
          onChange: onSelectChange,
        }}
        columns={columns}
        dataSource={dataSource}
        tableLayout="fixed"
        bordered
        pagination={false}
        scroll={{ y: "calc(100vh - 325px)", x: scrollX }}
        rowKey={rowKey}
        loading={isLoading}
      />
    </div>
  );
};

export default Datatable;

// import React, { useState } from "react";
// import { Table } from "antd";

// const Datatable = ({
//   columns,
//   dataSource,
//   isLoading,
//   totalCount,
//   rowKey,
//   scrollX = false,
// }) => {
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);

//   const rowSelection = {
//     selectedRowKeys,
//     onChange: (newSelectedRowKeys) => {
//       setSelectedRowKeys(newSelectedRowKeys);
//     },
//   };

//   return (
//     <div>
//       <Table
//         className="table datanew dataTable no-footer"
//         rowSelection={rowSelection}
//         columns={columns}
//         dataSource={dataSource}
//         tableLayout="fixed"
//         bordered
//         pagination={false}
//         scroll={{ y: "calc(100vh - 325px)", x: scrollX }}
//         rowKey={rowKey}
//         loading={isLoading}
//       />
//     </div>
//   );
// };

// export default Datatable;
